import { useEffect, useState } from "react";
import {
  SequenceService,
  type EngagementKeyDate,
  type PlannedTouch,
} from "@services/sequence/sequenceService";

/*
    Every campaign's Email & SMS sends in this engagement (MPN-2210).

    One request, and the send dates are the scheduler's own. The page used to render four
    invented playbooks anchored to invented January 2027 key dates -- which also stretched
    the chart's window and squashed the real ad flights somebody came to read -- and when it
    did compute a date it did so with a second implementation of the sender's arithmetic.

    Empty where the engagement has no campaign with a playbook switched on, which is most of
    them. The rows simply do not render, which is what the old permission gate was standing
    in for.
*/
export function useSequenceSchedule(engagementId: number) {
  const [touches, setTouches] = useState<PlannedTouch[]>([]);
  const [keyDates, setKeyDates] = useState<EngagementKeyDate[]>([]);

  useEffect(() => {
    if (!engagementId || engagementId < 0) {
      setTouches([]);
      setKeyDates([]);
      return;
    }
    let cancelled = false;
    new SequenceService()
      .getEngagementSequenceSchedule(engagementId)
      .then((data) => {
        if (cancelled) return;
        setTouches(data.touches);
        setKeyDates(data.key_dates);
      })
      .catch(() => {
        // A user without the Email & SMS feature gets a 403 here. No rows is the correct
        // rendering for them, and a chart that refuses to draw because of it is not.
        if (!cancelled) {
          setTouches([]);
          setKeyDates([]);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [engagementId]);

  return { touches, keyDates };
}
